"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconSizesInPxByName = exports.defaultGetIconSizeInPx = exports.iconSizeNames = void 0;
var breakpoints_1 = require("./breakpoints");
exports.iconSizeNames = [
    "extra small",
    "small",
    "default",
    "medium",
    "large",
];
var defaultGetIconSizeInPx = function (_a) {
    var sizeName = _a.sizeName, windowInnerWidth = _a.windowInnerWidth, rootFontSizePx = _a.rootFontSizePx;
    return rootFontSizePx *
        (function () {
            switch (sizeName) {
                case "extra small":
                    return 1;
                case "small":
                    if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                        return 1.25;
                    }
                    return 1;
                case "default":
                    if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                        return 1.5;
                    }
                    return 1.25;
                case "medium":
                    if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                        return 2;
                    }
                    return 1.25;
                case "large":
                    if (windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                        return 2.5;
                    }
                    if (windowInnerWidth >= breakpoints_1.breakpointsValues.lg) {
                        return 2;
                    }
                    return 1.5;
            }
        })();
};
exports.defaultGetIconSizeInPx = defaultGetIconSizeInPx;
function getIconSizesInPxByName(params) {
    var getIconSizeInPx = params.getIconSizeInPx, windowInnerWidth = params.windowInnerWidth, rootFontSizePx = params.rootFontSizePx;
    var out = {};
    exports.iconSizeNames.forEach(function (sizeName) {
        return (out[sizeName] = getIconSizeInPx({
            windowInnerWidth: windowInnerWidth,
            rootFontSizePx: rootFontSizePx,
            sizeName: sizeName,
        }));
    });
    return out;
}
exports.getIconSizesInPxByName = getIconSizesInPxByName;
//# sourceMappingURL=icon.js.map